import React, { FC } from 'react'
import { ConfigProvider as AntdConfigProvider } from 'antd'
import { StyleProvider } from '@ant-design/cssinjs'
import { defaulTheme } from './AntdThemeConfig'

interface IAntdThemeProviderProps {
  children: React.ReactNode
}

export const AntdThemeProvider: FC<IAntdThemeProviderProps> = ({
  children,
}) => {
  // ตรวจสอบว่าต้องการปิด CSS-in-JS หรือไม่
  const disableCSSinJS = process.env.REACT_APP_ANTD_DISABLE_CSSINJS === 'true'

  if (disableCSSinJS) {
    // ใช้ ConfigProvider เพียงอย่างเดียว ไม่ใช้ StyleProvider
    return (
      <AntdConfigProvider
        theme={defaulTheme}
        getPopupContainer={node => node?.parentElement || document.body}
      >
        {children}
      </AntdConfigProvider>
    )
  }

  // ใช้ StyleProvider สำหรับ production
  return (
    <StyleProvider hashPriority='high'>
      <AntdConfigProvider
        theme={defaulTheme}
        getPopupContainer={node => node?.parentElement || document.body}
      >
        {children}
      </AntdConfigProvider>
    </StyleProvider>
  )
}
